const OPENED_CLASS = 'dropdown-links--opened'
const DROPDOWN_CLASS = 'dropdown-links'

class DropdownLinks {
  constructor() {
  }

  openHandler(event) {
    event.stopPropagation()
    const currentTarget = event.currentTarget
    const linksContainer = currentTarget.querySelector('.dropdown-links__links')
    let openedDropdown = document.querySelector(`.${OPENED_CLASS}`);
    var equal = currentTarget.isEqualNode(openedDropdown);

    //Fix here
    if (openedDropdown && equal) {
      openedDropdown.classList.remove(OPENED_CLASS)
      openedDropdown.setAttribute('aria-selected', false)
      //let openedDropdownLinkContainer = openedDropdown.querySelector('.dropdown-links__links')
      //openedDropdownLinkContainer.setAttribute('aria-hidden', true)
      let heading = openedDropdown.querySelector('.levelOne-h6');
      let activeHeadings = openedDropdown.querySelector('.active');
      if (activeHeadings) {
        var text = activeHeadings.querySelector('.wizard-selector-h6').innerHTML;
        if (text.length > 30) {
          heading.innerHTML = text.substring(0, Math.min(30, text.lastIndexOf(" "))) + '...';
        } else {
          heading.innerHTML = text;
        }
      } else {
        if (openedDropdown.querySelector('.select-text')) {
          heading.innerHTML = openedDropdown.querySelector('.select-text').innerHTML;
        }
      }
    } else if (currentTarget === event.target && currentTarget.classList.contains(OPENED_CLASS)) {
      currentTarget.classList.remove(OPENED_CLASS)
      currentTarget.setAttribute('aria-selected', false)
      //linksContainer.setAttribute('aria-hidden', true)
    } else {
      currentTarget.classList.add(OPENED_CLASS)
      currentTarget.setAttribute('aria-selected', true)
      //linksContainer.setAttribute('aria-hidden', false)

      var links = linksContainer.querySelectorAll('.dropdown-links .level-title div');
      if (links.length > 0) {
        links.forEach(element => {
          if (element.clientHeight > 20) {
            element.classList.add('two-lines');
          }
        });
      }
    }
  }

  init() {
    this.dropdownNodes = document.querySelectorAll('.' + DROPDOWN_CLASS)

    if (this.dropdownNodes.length > 0) {
      for (let i = 0; i < this.dropdownNodes.length; i++) {
        const dropdownNode = this.dropdownNodes[i];

        dropdownNode.addEventListener('click', this.openHandler)
        dropdownNode.addEventListener('keydown', event => {
          event.stopImmediatePropagation()

          if (event.keyCode === 32 || event.keyCode === 13) {
            console.log('from keyboard', event.keyCode)
            this.openHandler(event)
          }
        })
      }

      document.addEventListener('click', event => {
        if (!event.target.classList.contains(DROPDOWN_CLASS)) {
          for (let i = 0; i < this.dropdownNodes.length; i++) {
            const dropdownNode = this.dropdownNodes[i]

            dropdownNode.classList.remove(OPENED_CLASS)
            dropdownNode.setAttribute('aria-selected', false)
            //dropdownNode.querySelector('.dropdown-links__links').setAttribute('aria-hidden', true)
          }
        }
      })
    }
  }
}

export default DropdownLinks;